import { render } from "./empty-layout.vue?vue&type=template&id=26ae4fbd"
const script = {}

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__